import styles from "./PPTInstallGuidePage.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import React, {useEffect, useState} from "react";
import {
    LEARN_MORE_TEXT,
    NEED_HELP_TEXT,
    NOTE_PREFIX,
    PPT_INSTALL_STEP1_BUTTON_TEXT,
    PPT_INSTALL_STEP1_SUB_1,
    PPT_INSTALL_STEP1_SUB_2,
    PPT_INSTALL_STEP1_TITLE,
    PPT_INSTALL_STEP2_TITLE,
    PPT_INSTALL_STEP3_SUB_1,
    PPT_INSTALL_STEP3_TITLE,
    PPT_INSTALL_STEP4_SUB_1,
    PPT_INSTALL_STEP4_TITLE,
    PPT_INSTALLATION_LEARN_MORE_LINK,
    PPT_INSTALLATION_OVERVIEW_LINK,
    PPT_INSTALLATION_STEP_1_LINK,
    PPT_INSTALLATION_STEP_2_LINK,
    PPT_INSTALLATION_STEP_3_LINK,
    PPT_INSTALLATION_STEP_4_LINK,
    PPT_PLUGIN_INSTALL_ZIP_FILE_NAME,
    YUJA_SUPPORT_LINK,
} from "../../utils/constants";

import {ReactComponent as QUESTION_MARKER} from "../../images/question_marker_purple.svg"
import {useConfig} from "../../hooks/useConfig";


export default function PPTInstallGuidePage() {
    const config = useConfig();
    const [downloadLink, setDownloadLink] = useState("");

    useEffect(() => {
        const url = `${config.s3.public_access_url}/${PPT_PLUGIN_INSTALL_ZIP_FILE_NAME}`;
        const requestOptions = {method: "GET"};
        fetch(url, requestOptions).then((response) => {
            return response.blob();
        })
            .then((blob) => URL.createObjectURL(blob))
            .then((href) => {
                setDownloadLink(href);
            });
    }, []);

    const handleDownload = () => {
        if (downloadLink) {
        const link = document.createElement('a');
        link.href = downloadLink;
        link.download = PPT_PLUGIN_INSTALL_ZIP_FILE_NAME;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        }
    };

    return (
        <>

            <div style={{height: 10}}/>
            <div className={styles.starterBanner}>
                <div className={styles.column} style={{flex: 1, minWidth: 470, gap: 25}}>
                    <span>{"Set up your YuJa Engage PowerPoint Experience"}</span>
                    <span className={styles.description} style={{"color": "#4A4A4A"}}>
                        {"Follow the steps below to integrate Engage with PowerPoint."}
                    </span>
                </div>

                <iframe
                    title={"Set up your YuJa Engage PowerPoint Add-in guideline"}
                    allowFullScreen={true}
                    style={{
                        width: 287,
                        height: "auto",
                        aspectRatio: "16 / 9",
                        borderRadius: 4,
                        marginRight: 40
                    }}
                    src={PPT_INSTALLATION_OVERVIEW_LINK}
                />
            </div>
            <div style={{height: 30}}/>
            <div className={styles.column} style={{gap: 20}}>
                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>1</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{PPT_INSTALL_STEP1_TITLE}</span>
                        <span className={styles.description}>{PPT_INSTALL_STEP1_SUB_1}</span>
                        <span className={styles.description}>
                            <span style={{
                                color: "#000",
                                fontWeight: "600",
                                marginRight: 5
                            }}>{NOTE_PREFIX}</span>{PPT_INSTALL_STEP1_SUB_2}
                            <span
                                tabIndex={0}
                                className={styles.link}
                                style={{marginLeft: 3}}
                                onClick={() => window.open(PPT_INSTALLATION_LEARN_MORE_LINK)}
                            >{LEARN_MORE_TEXT}.</span>
                        </span>
                        <YuJaButton onClick={handleDownload} style={{marginTop: 15, height: 36}}>
                            {PPT_INSTALL_STEP1_BUTTON_TEXT}
                        </YuJaButton>
                    </div>


                    <iframe
                        title={"YuJa Engage PowerPoint Add-in guideline step 1"}
                        allowFullScreen={true}
                        style={{
                            width: 355,
                            height: "auto",
                            aspectRatio: "16 / 9",
                            borderRadius: 4,
                            marginRight: 40
                        }}
                        src={PPT_INSTALLATION_STEP_1_LINK}
                    />


                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>2</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{PPT_INSTALL_STEP2_TITLE}</span>
                        <span className={styles.description}>{PPT_INSTALL_STEP1_SUB_1}</span>
                    </div>

                    <iframe
                        title={"YuJa Engage PowerPoint Add-in guideline step 2"}
                        allowFullScreen={true}
                        style={{
                            width: 355,
                            height: "auto",
                            aspectRatio: "16 / 9",
                            borderRadius: 4,
                            marginRight: 40
                        }}
                        src={PPT_INSTALLATION_STEP_2_LINK}
                    />
                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>3</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{PPT_INSTALL_STEP3_TITLE}</span>
                        <span className={styles.description}>{PPT_INSTALL_STEP3_SUB_1}</span>
                    </div>

                    <iframe
                        title={"YuJa Engage PowerPoint Add-in guideline step 3"}
                        allowFullScreen={true}
                        style={{
                            width: 355,
                            height: "auto",
                            aspectRatio: "16 / 9",
                            borderRadius: 4,
                            marginRight: 40
                        }}
                        src={PPT_INSTALLATION_STEP_3_LINK}
                    />
                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>4</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{PPT_INSTALL_STEP4_TITLE}</span>
                        <span className={styles.description}>{PPT_INSTALL_STEP4_SUB_1}</span>
                    </div>

                    <iframe
                        title={"YuJa Engage PowerPoint Add-in guideline step 4"}
                        allowFullScreen={true}
                        style={{
                            width: 355,
                            height: "auto",
                            aspectRatio: "16 / 9",
                            borderRadius: 4,
                            marginRight: 40
                        }}
                        src={PPT_INSTALLATION_STEP_4_LINK}
                    />
                </div>

                {/*<span*/}
                {/*    style={{*/}
                {/*        display: "flex",*/}
                {/*        fontSize: 14,*/}
                {/*        lineHeight: "160%",*/}
                {/*        color: "#191520",*/}
                {/*        alignSelf: "center",*/}
                {/*        alignItems: "center"*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <QUESTION_MARKER style={{marginRight: 5, width: 32, height: 32}}/>*/}
                {/*    {NEED_HELP_TEXT}*/}
                {/*    <span*/}
                {/*        tabIndex={0}*/}
                {/*        className={styles.link}*/}
                {/*        style={{marginLeft: 5}}*/}
                {/*        onClick={() => window.open(YUJA_SUPPORT_LINK)}*/}
                {/*    >{"YuJa Support"}</span>*/}
                {/*</span>*/}

            </div>
        </>
    );
}